<script>
  let { position, block } = $props();
</script>

<g class="legend" transform="translate({position[0]}, {position[1]})">
  <circle cx="8" cy="-3" r="3" stroke="#666" fill="none"></circle>
  <text x="14" y="1">{block.pollLabel}</text>
</g>

<style lang="scss">
  text {
    font-size: 13px;
    fill: #666;
  }
  @media (max-width: 500px) {
    text {
      font-size: 11px;
    }
  }
</style>
